import * as React from "react";
import { Fragment, useState } from "react";
import {
  Button,
  Confirm,
  useUpdateMany,
  useRefresh,
  useNotify,
  useUnselectAll,
} from "react-admin";

import EuroIcon from "@material-ui/icons/Euro";

const BulkPremiumButton = ({ selectedIds }) => {
  const [open, setOpen] = useState(false);
  const refresh = useRefresh();
  const notify = useNotify();
  const unselectAll = useUnselectAll();
  const [updateMany, { loading }] = useUpdateMany(
    "gse/attivaPremium",
    selectedIds,
    { views: 0 },
    {
      onSuccess: () => {
        refresh();
        notify("Premium attivato");
        unselectAll("gse/attivaPremium");
      },
      onFailure: (error) => notify("Errore", { type: "warning" }),
    }
  );
  const handleClick = () => setOpen(true);
  const handleDialogClose = () => setOpen(false);

  const handleConfirm = () => {
    updateMany();
    setOpen(false);
  };

  return (
    <Fragment>
      <Button label="Attiva premium" onClick={handleClick}>
        <EuroIcon />
      </Button>
      <Confirm
        isOpen={open}
        loading={loading}
        title="Attivare premium"
        content="Sei sicuro di voler attiavre il premium sugli impianti selezionati?"
        onConfirm={handleConfirm}
        onClose={handleDialogClose}
      />
    </Fragment>
  );
};

export default BulkPremiumButton;
